"use client"
import React from "react";
import Input from "@/components/common/Input.jsx";
import styled from "styled-components";
import {observer} from "mobx-react";
import {useRouter} from "next/navigation";
import {SIZES} from "@/components/constants";

const Table = observer(({ data, columns, offset, dataAllCount, store, setAllCheck = null, checkType, setOffset, menuId, columnsControl}) => {
    const resolvedColumns = columns();
    const router = useRouter();
    return (
        <TableWrap className={`${columnsControl && data && data.length > 0 ? "control" : ""}`}>
            <thead>
            <tr>
                {resolvedColumns.map((col, idx) => (
                    <th key={idx} style={{width: col.width || "auto", minWidth: col.minWidth || "auto"}}>
                        {col.type === "checkbox" ? (
                            <div className={"flex al-center jc-center"}>
                                <Input
                                    inputType="checkbox"
                                    id="list-all-check"
                                    // checked={store.searchBaseStore.getAllChecked(data, checkType, "rowId")}
                                    // onChange={(e) => {
                                    //     if (setAllCheck) setAllCheck();
                                    //     store.searchBaseStore.setAllChecked(data, e.target.checked, checkType, "rowId");
                                    // }}
                                    checked={store.searchBaseStore.getAllChecked(data, checkType)}
                                    onChange={(e) => {
                                        if (setAllCheck) setAllCheck();
                                        store.searchBaseStore.setAllChecked(data, e.target.checked, checkType);
                                    }}
                                />
                            </div>
                        ) : (
                            col.label || ""
                        )}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {
                data && data.length > 0 ?
                    data.map((rowItem, rowKey) => (
                        <tr key={rowKey} onClick={() => {
                            if(columnsControl && data && data.length > 0){
                                let type;
                                if(rowItem.subType === "LIST") {
                                    type = "list";
                                } else if(rowItem.subType === "GALLERY"){
                                    type = "gallery";
                                } else if(rowItem.subType === "BLOG"){
                                    type = "blog";
                                }
                                router.push(`/homepage/management/detail?menu-id=${rowItem.menuId}&content-id=${rowItem._id}&content-type=${type}`);
                            }

                        }}>
                            {resolvedColumns.map((colItem, colKey) => (
                                <td key={colKey}>
                                    {colItem.render(rowKey, rowItem, offset, dataAllCount, checkType, setOffset, menuId)}
                                </td>
                            ))}
                        </tr>
                    ))
                    : <tr>
                        <td className={"no-data"} colSpan={resolvedColumns.length}>
                            데이터가 존재하지 않습니다.
                        </td>
                    </tr>
            }
            </tbody>
        </TableWrap>
    );
});


const TableWrap = styled.table`
    width: 100%;
    table-layout: fixed;
    thead {
        th {
            color: ${({theme}) => theme.COLORS.TABLE.font.head};
            font-weight: ${({theme}) => theme.SIZE.TABLE.THEAD.weight};
            font-size: ${({theme}) => theme.SIZE.TABLE.THEAD.font};
            background-color: ${({theme}) => theme.COLORS.TABLE.head};
            border-bottom: 1px solid ${({theme}) => theme.COLORS.TABLE.border};
            height: ${({theme}) => theme.SIZE.TABLE.THEAD.height};
            text-align: center;
            vertical-align: middle;
            white-space: pre-line;
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #E6E6E6;
        }
        td {
            padding: 5px 0;
            vertical-align: middle;
            color: ${({theme}) => theme.COLORS.TABLE.font.body};
            font-weight: ${({theme}) => theme.SIZE.TABLE.TBODY.weight};
            font-size: ${({theme}) => theme.SIZE.TABLE.TBODY.font};
            border-bottom: 0;
            text-align: center;
            height: ${({theme}) => theme.SIZE.TABLE.TBODY.height};
            line-height: 1.25;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            *:not(.input-wrapper):not(.input-wrapper *) {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
    &.control{
        tbody {
            tr {
                cursor: pointer;
            }
        }
        tbody {
            tr{
                &:hover{
                    td {
                        background-color: ${({theme}) => theme.COLORS.TABLE.head};
                    }
                }
            }
        
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        &.control{
            tbody {
                tr {
                    cursor: pointer;
                }
            }
            tbody {
                tr{
                    &:hover{
                        td {
                            background-color: #fff;
                        }
                    }
                }

            }
        }
    }
`

export default Table;
